import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { guardarNombreEmpresa } from '../../actions/auth';
import { ProgressBar } from '../shared/ProgressBar';
import Swal from 'sweetalert2';

export const PasoNombre = ({ siguiente }) => {
    const dispatch = useDispatch();
    const [nombre, setNombre] = useState('');
    const [cargando, setCargando] = useState(false);

    const handleContinuar = async () => {
        if (!nombre.trim()) return;
        setCargando(true);
        try {
            await dispatch(guardarNombreEmpresa(nombre.trim()));
            siguiente();
        } catch (e) {
            Swal.fire('Error', 'No se pudo guardar el nombre. Intenta de nuevo.', 'error');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="app-container">
            <div className="app-header">
                <h1>¡Hola! Configura tu negocio</h1>
                <p>Solo toma unos minutos 💅</p>
            </div>
            <ProgressBar paso={1} />

            <div className="screen-body">
                <div className="field-label">¿Cómo se llama tu negocio?</div>
                <input
                    className="field-input"
                    placeholder="Ej. Nails by Lupita"
                    value={nombre}
                    onChange={e => setNombre(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && handleContinuar()}
                    autoFocus
                    maxLength={60}
                />
                <p className="field-hint">Así te van a conocer tus clientas</p>

                <div className="info-box" style={{ marginTop: 20 }}>
                    <div className="info-box-title">¿Para qué usamos el nombre?</div>
                    <div className="info-box-body">
                        Tus clientas escribirán al WhatsApp de Revi mencionando tu negocio para reservar una cita contigo. Por ejemplo:<br /><br />
                        <span style={{ fontStyle: 'italic', color: 'var(--pink-600)' }}>
                            "Quiero reservar con {nombre || 'Nails by Lupita'}"
                        </span>
                    </div>
                </div>
            </div>

            <div className="screen-footer">
                <button
                    className="btn-primary"
                    onClick={handleContinuar}
                    disabled={!nombre.trim() || cargando}
                >
                    {cargando ? 'Guardando...' : 'Continuar'}
                </button>
            </div>
        </div>
    );
};
